{"schemaVersion":1,"release":{"version":"1.0.6","build":153,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.0.6-153.dmg","sha256":"dd7a53283ee0950e120913954d99b3b1fbef1a846209e013cfe12030065cb7f4","size":28958611}}
